import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import fr from "./translations/fr/fr.json";
import en from "./translations/en/en.json";
import ar from "./translations/ar/ar.json";
import nl from "./translations/nl/nl.json";
import ua from "./translations/ua/ua.json";
import pt from "./translations/pt/pt.json";
import it from "./translations/it/it.json";
import de from "./translations/de/de.json";
import es from "./translations/es/es.json";
import fi from "./translations/fi/fi.json";
import zh from "./translations/zh/zh.json";

const resources = {
  fr: {
    translation: fr,
  },
  en: {
    translation: en,
  },
  ar: {
    translation: ar,
  },
  nl: {
    translation: nl,
  },
  ua: {
    translation: ua,
  },
  pt: {
    translation: pt,
  },
  it: {
    translation: it,
  },
  de: {
    translation: de,
  },
  es: {
    translation: es,
  },
  fi: {
    translation: fi,
  },
  zh: {
    translation: zh,
  },
};

const LANGUAGE_STORAGE_KEY = "selectedLanguage";

const getSavedLanguage = () => {
  const selectedLanguage = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  return selectedLanguage || "fr"; // Valeur par défaut si aucune langue n'a été enregistrée
};

const setLanguage = (lng: string) => {
  localStorage.setItem(LANGUAGE_STORAGE_KEY, lng);
};

i18n.use(initReactI18next).init({
  resources,
  lng: getSavedLanguage(),
  interpolation: {
    escapeValue: false,
  },
});

export { setLanguage };
export default i18n;
